export enum StoreIds {
  PersonStore = 'person-store',
  CountriesStore = 'countries-store',
  CustomFiltersStore = 'custom-filters-store',
  AssignedCourseStore = 'assigned-courses-store'
}
